module.exports = __webpack_public_path__ + "static/rock_video-006dc8ac936d070389d8b44c45e31805.mp4";